// AUTO-GENERATED by `pnpm --filter @borradh-workspace/contracts contracts:generate`.
// DO NOT EDIT — regenerate instead. Source: Drizzle table "treatment_plan_delivery".
// This file is pure Zod (no drizzle-zod / database in its runtime graph).
import { z } from 'zod';
/** Response atom for the "treatment_plan_delivery" table (1:1 with a DB row, on the wire). */
export const treatmentPlanDeliveryAtomSchema = z.object({
    id: z.string(),
    treatmentPlanId: z.string(),
    organizationId: z.string(),
    channel: z.enum(['email', 'portal', 'whatsapp', 'sms']),
    recipientEmail: z.string().nullable(),
    sentAt: z.string().datetime(),
    sentById: z.string().nullable(),
});
//# sourceMappingURL=treatmentPlanDelivery.js.map